/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotChatService
 */
import * as References from './CopilotChatService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotChatService#startChat
 */
export const START_CHAT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotChatService_startChat';
export const START_CHAT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_CHAT_MUTATION_FIELD_NAME,
  args: ['customCopilotId', 'isTemporary'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.startChatRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotChatService#createAuthToken
 */
export const CREATE_AUTH_TOKEN_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotChatService_createAuthToken';
export const CREATE_AUTH_TOKEN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_AUTH_TOKEN_MUTATION_FIELD_NAME,
  args: ['clientId', 'threadId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.createAuthTokenRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});